import { MessageCircle, ArrowRight, ShieldCheck, Award, Hammer, Building2, Package } from "lucide-react";
import { buildWhatsAppUrl, trackEvent } from "@/lib/utm";

const heroImg = "/images/nicho_estacionamientos_foto.jpeg";

export default function Hero() {
  const wa = buildWhatsAppUrl(
    "5218116289267",
    "Hola Eclipse, quiero una cotizacion gratis de FlexShade. Me contactaron por la pagina."
  );
  return (
    <section id="hero" className="relative min-h-[92vh] md:min-h-screen flex items-center overflow-hidden bg-black">
      <img
        src={heroImg}
        alt="Estacionamiento con techo de malla sombra FlexShade en Monterrey"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
        fetchpriority="high"
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative container-x py-28 md:py-24 w-full">
        <div className="max-w-3xl">
          <span className="eyebrow text-white bg-red-600/20 border-red-500/40" style={{color: '#fca5a5'}}>ECLIPSE &middot; 20 AÑOS &middot; +10,000 TECHOS INSTALADOS</span>
          <h1 className="mt-5 text-white font-black text-5xl sm:text-6xl md:text-7xl lg:text-8xl section-title leading-[0.95]">
            Techos de malla sombra para <span className="text-orange-500">estacionamientos</span> en Monterrey
          </h1>
          <p className="mt-4 text-orange-400 italic text-xl md:text-2xl font-light tracking-wide" data-testid="hero-slogan">
            Te dejamos cubierto.
          </p>
          <p className="mt-5 text-white/85 text-lg md:text-xl max-w-2xl leading-relaxed">
            Sistema modular prefabricado <strong className="text-white">FlexShade</strong>.
            No requiere permiso de construcción &middot; Instalación inmediata &middot; Garantía por escrito hasta 10 años.
          </p>
          <div className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-500/15 border border-orange-400/40 text-orange-200 text-sm font-semibold" data-testid="hero-inventory-badge">
            <Package className="w-4 h-4" />
            Contamos con inventario listo para instalar
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href={wa}
              target="_blank"
              rel="noreferrer"
              onClick={() => trackEvent("whatsapp_click", { location: "hero_cta" })}
              className="btn-wa px-6 md:px-7 py-4 rounded-xl inline-flex items-center justify-center gap-2 text-base md:text-lg"
              data-testid="hero-whatsapp"
            >
              <MessageCircle className="w-5 h-5" />
              Cotiza gratis por WhatsApp
            </a>
            <a
              href="#modelos"
              className="btn-outline-light px-6 md:px-7 py-4 rounded-xl inline-flex items-center justify-center gap-2 text-base"
              data-testid="hero-models"
            >
              Ver modelos disponibles <ArrowRight className="w-5 h-5" />
            </a>
          </div>

          {/* Trust bar */}
          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl">
            {[
              { icon: Award, label: "Premio IFAI 2021" },
              { icon: Hammer, label: "20 años de experiencia" },
              { icon: Building2, label: "+10,000 techos" },
              { icon: ShieldCheck, label: "Garantía por escrito" },
            ].map((it, idx) => (
              <div key={idx} className="trust-bar-item">
                <it.icon className="w-5 h-5 text-orange-500 mb-1" />
                <p className="text-white/90 text-sm font-semibold leading-tight">{it.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2 text-white/60 text-xs tracking-widest">
        <span>SCROLL</span>
        <div className="w-px h-8 bg-white/30 animate-pulse" />
      </div>
    </section>
  );
}
